import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue'
  import Tabs from '@/components/common/Tabs.vue'
  import CourseTile from '@/components/course/sections/CourseTile.vue'
  import useI18n from '@/composables/useI18n'
  import type { PropType } from 'vue'
  import type { CourseItem } from '@/services/interfaces/Course'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'TabGroupedCourses',
  props: {
    courses: {
      type: Array as PropType<CourseItem[]>,
      required: true,
    },
  },
  setup(__props) {

const props = __props;

  

  const { translateString } = useI18n()

  const activeTabIndex = ref(0)
  const inactiveTabIndexes = ref([] as number[])

  const courseGroupings = computed(() => [
    `${translateString('trainings.tabbed.inPossession')} <span>${filteredCourses.value(0)?.length}</span>`,
    `${translateString('trainings.tabbed.inTest')} <span>${filteredCourses.value(1)?.length}</span>`,
    `${translateString('trainings.tabbed.further')} <span>${filteredCourses.value(2)?.length}</span>`,
  ])

  const filteredCourses = computed(() => (activeTab: number) => {
    return props.courses.filter((c) => {
      if (activeTab === 0) {
        return c.purchased
      } else if (activeTab === 1) {
        return c.trial && !c.purchased
      } else {
        return !c.trial && !c.purchased
      }
    })
  })

  const setInactiveTabIndexes = () => {
    // we have 3 tabs
    for (let i = 0; i < 3; i++) {
      if (!(filteredCourses.value(i).length > 0)) {
        inactiveTabIndexes.value.push(i)
      }
    }
  }

  const setActiveTabIndex = () => {
    for (let i = 2; i >= 0; i--) {
      if (filteredCourses.value(i).length > 0) {
        activeTabIndex.value = i
      }
    }
  }

  setActiveTabIndex()
  setInactiveTabIndexes()

return { __sfc: true,props, translateString, activeTabIndex, inactiveTabIndexes, courseGroupings, filteredCourses, setInactiveTabIndexes, setActiveTabIndex, computed, ref, Tabs, CourseTile, useI18n }
}

})